import request from '../../utils/request'

// 分页查询
export function fetchList (data) {
  return request.post('/pc/rhPhoneExchangeRecord/page', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/pc/rhPhoneExchangeRecord/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/pc/rhPhoneExchangeRecord/delete/batch', {
    params: {
      ids
    }
  })
}
